module.exports = __webpack_public_path__ + "static/media/training.466e5a72.svg";